import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import googleDriveActions from 'redux/actions/googleDriveActions'
import generalActions from 'redux/actions/generalActions'
import confirmTypes from 'helpers/enums/confirmTypes'
import { localize } from 'helpers/translator'

const CONFIRM_TYPE = confirmTypes.GOOGLE_SLIDES_LMS_REFRESH_CONFIRM

class GoogleSlidesLMSRefresh extends PureComponent {

	close = () => {
		this.props.actions.close(CONFIRM_TYPE)
	}

	render() {
		return (
			<Confirm
				btTwo={localize('global_ok')}
				alertTitle={localize('googleSlides_lmsRefresh_title')}
				alertMessage={localize('googleSlides_lmsRefresh')}
				actionButtonType={0}
				actionTwo={this.props.actions.refresh}
				closeAction={this.close}
			/>
		)
	}
}

GoogleSlidesLMSRefresh.propTypes = {
	actions: PropTypes.shape({
		refresh: PropTypes.func.isRequired,
		close: PropTypes.func.isRequired,
	}).isRequired,
}


function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		refresh: googleDriveActions.LMSRefreshConfirmed,
		close: generalActions.closeConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(GoogleSlidesLMSRefresh)

export { GoogleSlidesLMSRefresh }
